module.exports = __webpack_public_path__ + "img/oaks-nest-double-sconce-1.03faaeaf.jpeg";